<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#FBFBFB`} 
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh;padding-top:87px">
      <div style="max-height:100%; overflow:auto">
        <div v-if="loading" class="strategio-loading-main">
          <p>
            <v-progress-circular style="color:#00C3D7;" indeterminate size="50"></v-progress-circular>
            <br />
            <span class="strategio-loading-main-message">
              Un momento por favor
            </span>
          </p>
        </div>
        <div 
          v-else
          style="overflow: hidden"
          class="strategio-titles-windows"
        >
          <v-container>
            <v-row>
              <v-col cols="5" align-self="center">
                <v-icon  :color="'black'"  style="font-size:52px;padding-bottom: 30px; padding-right: 10px;"
                >mdi-cloud-download</v-icon>
                <span style="font-size:45px;font-weight:bold;color:black;-webkit-text-stroke: 2px black;">
                  Descargar Cubo
                </span>
              </v-col>
            </v-row>
            <v-row class="mb-2" v-if="isAdmin && folderID !== '0'">
              <v-col cols="12">
                Acceso a todos los usuarios para que visualicen estos cubos
              </v-col>
              <v-btn
                :disabled="disabledButton"
                :loading="actualizarButtonLoading"
                color="#2262c6"
                class="ma-2 white--text"
                :style="[
                  {'width': actualizarButtonLoading ? '190px' : ''},
                ]"
                @click="actualizar()"
              >
                Permitir
                <v-icon
                  right
                  dark
                >
                  mdi-account-check
                </v-icon>

                <template v-slot:loader>
                  <span>Actualizando</span>
                  <v-progress-circular
                    indeterminate
                    size="16"
                    color="primary"
                    class="ml-1"
                  ></v-progress-circular>
                </template>
              </v-btn>
              <v-btn
                :disabled="disabledButton"
                :loading="bloquearButtonLoading"
                color="#2262c6"
                class="ma-2 white--text"
                @click="bloquear()"
                :style="[
                  {'width': bloquearButtonLoading ? '190px' : ''},
                ]"
              >
                Bloquear
                <v-icon
                  right
                  dark
                >
                  mdi-account-cancel
                </v-icon>

                <template v-slot:loader>
                  <span>Bloqueando</span>
                  <v-progress-circular
                    indeterminate
                    size="16"
                    color="primary"
                    class="ml-1"
                  ></v-progress-circular>
                </template>
              </v-btn>
            </v-row>
            <div v-if="reports.length !== 0 && folderID !== '0'">
              <report-list
                :reports="reports"
                :contained-by="containedBy"
                :is-searching="searchInfo !== ''"
                :search-props="searchProps"
                :search-items="searchItemsByTag"
                :hide-favorite-icon="true"
              ></report-list>
            </div>
            <div
              v-else
              class="download-cube-no-report">
              <div v-if="folderID === '0'">
                <div v-if="isAdmin">
                  Todavía no se ha creado la carpeta para agregar los reportes de cubos
                  <br>
                  Agregue la carpeta de descarga de cubo con el siguiente botón.
                  <v-btn
                    class="ma-2"
                    outlined
                    large
                    fab
                    color="white"
                    style="background-color: #2262C6;"
                    @click="createDownloadCubeFolder()"
                  >
                    <v-icon>create_new_folder</v-icon>
                  </v-btn>
                </div>
                <div v-else>
                  No tiene permiso para visualizar los cubos.
                  <br>
                  Por favor comuniquese con soporte.
                </div>
              </div>
              <div v-else>
                <div v-if="isAdmin">
                  No hay reporte de cubo creado.
                  <br>
                  Agregue un reporte de cubo con el siguiente botón.
                  <v-btn
                    class="ma-2"
                    outlined
                    large
                    fab
                    color="white"
                    style="background-color: #2262C6;"
                    @click="addReport()"
                  >
                    <v-icon>note_add</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            
          </v-container>
        </div>

        <v-speed-dial
          id="options-button"
          fixed
          v-model="fab"
          bottom
          right
          direction="top"
          transition="scale-transition"
          elevation-6
          v-if="isAdmin"
          v-show="searchInfo === ''"
          class="strategio-speed-dial"
        >
          <v-btn
            slot="activator"
            fab
            hover
            large
            v-model="fab"
          >
            <v-icon v-if="fab">close</v-icon>
            <v-icon v-else>add</v-icon>
            
          </v-btn>
          <v-tooltip left open-on-hover>
            <v-btn
              fab
              small
              slot="activator"
              @click="addReport()"
            >
              <v-icon style="font-size:26px" color="grey darken-1">note_add</v-icon>
            </v-btn>
            <span>Crear reporte</span>
          </v-tooltip>
          <!-- <v-tooltip left open-on-hover>
            <v-btn
              fab
              small
              slot="activator"
              @click="addFolder()"
            >
              <v-icon style="font-size:26px" color="grey darken-1">create_new_folder</v-icon>
            </v-btn>
            <span>Crear folder</span>
          </v-tooltip> -->
        </v-speed-dial>

      </div>

    </v-main>

    <custom-snack-bar></custom-snack-bar>
    <folder-form-dialog></folder-form-dialog>
    <report-form-dialog></report-form-dialog>
    <new-items-manager-dialog></new-items-manager-dialog>
    <drop-item-dialog></drop-item-dialog>
    <replicate-folder-dialog></replicate-folder-dialog>
    <show-users-folder-permissions></show-users-folder-permissions>
  </div>
</template>

<script>
import {map} from 'lodash'

import eventBus from '../utils/eventBus'

import FolderList from '../components/folders/folder-list.vue'
import ReportList from '../components/reports/report-list.vue'
import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'

import FolderFormDialog from '../components/dialogs/folder-form-dialog.vue'
import ReportFormDialog from '../components/dialogs/report-form-dialog.vue'
import DropItemDialog from '../components/dialogs/drop-item-dialog.vue'
import ReplicateFolderDialog from '../components/dialogs/replicate-folder-dialog.vue'
import NewItemsManagerDialog from '../components/dialogs/new-items-manager-dialog.vue'
import ShowUsersFolderPermissions from '../components/dialogs/show-users-folder-permissions.vue'

import CustomSnackBar from '../components/snackbars/custom-snack-bar.vue'

import userStorage from '../storage/userStorage'
import reportsStorage from '../storage/reportsStorage'
import uris from '../utils/uris'
import axios from '../utils/axiosWrapper'

export default {
  name: 'main-page',
  data () {
    return {
      folders: [],
      reports: [],
      containedBy: '0',
      folderID: '0',
      loading: false,
      isAdmin: userStorage.getUserInfo().userType === 'ADMIN',
      fab: false,
      searchInfo: '',
      searchCriteria: '',
      hideSearchBar: true,
      searchProps: {
        searchCriteria: ''
      },
      disabledButton: false,
      actualizarButtonLoading: false,
      bloquearButtonLoading: false
    }
  },
  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.searchProps.searchCriteria = ''
    this.searchInfo = ''

    // this.loadFolders(this.folderID)
    this.loadAll(this.folderID, false)
    next()
  },
  mounted () {
    this.loadAll(this.folderID)

    eventBus.$off('toggle-search-bar')
    eventBus.$on('toggle-search-bar', () => {
      this.hideSearchBar = !this.hideSearchBar
    })
  },
  created () {
    eventBus.$off('reload-items')
    eventBus.$on('reload-items', (data) => {
      this.searchProps.searchCriteria = ''
      this.searchInfo = ''

      this.loadAll(this.folderID, true)
    })
  },
  methods: {
    loadAll (_folderID, _forceLoad) {
      if (_forceLoad) {
        // Actualiza el árbol total de items antes de traer
        //  los items de este directorio
        reportsStorage.getData({
          forceLoad: true,
          onSuccess: () => {
            // eslint-disable-next-line
            this.loadFolders(_folderID)
          }
        })
      } else {
        this.loadFolders(_folderID)
      }
    },
    loadFolders (_folderID, _forceLoad) {
      this.loading = true
      const folderID = _folderID || '0'
      const forceLoad = _forceLoad || false
      reportsStorage.getData({
        forceLoad,
        folderID,
        onSuccess: (data) => {
          const _folders = []
          const _reports = []

          map(data, (item, index) => {
            if (item.isFolder) {
              _folders.push(item)
            } else {
              _reports.push(item)
            }
          })

          this.folders = _folders
          this.reports = _reports
          this.containedBy = reportsStorage.findItemByID(folderID)

          let existFolderDownloadCube = reportsStorage.findItemByName('download-cube')
          if (existFolderDownloadCube) {
            let reloadPage = this.folderID === '0'
            this.folderID = existFolderDownloadCube.itemID
            this.loading = false
            if (reloadPage) {
              this.loadAll(this.folderID)
            }
          } else {
            this.loading = false
          }
        },
        onError: (error) => {
          let message = 'Error desconocido'
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data)
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request)
            message = 'No pudimos obtener respuesta del servidor'
          } else {
            // Something happened in setting up the request that triggered an Error
            message = `Error desconocido: ${error.message}`
          }
          this.loading = false
          // emits to components/snackbars/custom-snack-bar.vue
          eventBus.$emit('open-custom-snack-bar', {message, itsOk: false})
        }
      })
    },
    searchItems () {
      const searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/)
      let isValid = true
      for (let i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false
          break
        }
      }

      if (!isValid) {
        eventBus.$emit('open-custom-snack-bar', {message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning'})
        return
      }

      const data = reportsStorage.searchItems(searchQuery)

      const _folders = []
      const _reports = []
      data.map((item, index) => {
        if (item.isFolder) {
          _folders.push(item)
        } else {
          _reports.push(item)
        }
      })
      this.folders = _folders
      this.reports = _reports
      if (data.length > 0) {
        this.searchInfo = `${_reports.length} reportes y ${_folders.length} carpetas en ${data.length}/${reportsStorage.storeLength()} elementos`
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda'
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    searchItemsByTag () {
      const searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/)
      let isValid = true
      /* for (let i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false
          break
        }
      } */

      if (!isValid) {
        eventBus.$emit('open-custom-snack-bar', {message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning'})
        return
      }

      const data = reportsStorage.searchItems(searchQuery)

      const _folders = []
      const _reports = []
      data.map((item, index) => {
        if (item.isFolder) {
          _folders.push(item)
        } else {
          _reports.push(item)
        }
      })
      this.folders = _folders
      this.reports = _reports
      if (data.length > 0) {
        this.searchInfo = `${_reports.length} reportes y ${_folders.length} carpetas en ${data.length}/${reportsStorage.storeLength()} elementos`
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda'
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    createDownloadCubeFolder () {
      this.loading = true
      reportsStorage.addItem({
        data: {
          itemName: 'download-cube',
          containedBy: '0',
          isFolder: true,
          inherited: 0,
          structureItemInheritance: false
        },
        onSuccess: (response) => {
          this.folderID = response.data.item.itemID
          // reportsStorage.hideItem(response.data.item.itemID)
          eventBus.$emit('reload-items')
        },
        onError: (error) => {
          console.warn('Error en crear la carpeta download-cube', error)
        }
      })
    },
    addReport () {
      const parentFolder = this.folderID

      // emit to components/dialogs/report-form-dialog.vue
      eventBus.$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        parentName: this.containedBy && this.containedBy.itemName,
        structureID: this.containedBy && this.containedBy.origin
      })
    },
    addInnerReport (folderData) {
      const parentFolder = folderData.itemID
      // emit to components/dialogs/report-form-dialog.vue
      eventBus.$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        parentName: folderData.itemName,
        structureID: folderData.origin
      })
    },
    addFolder () {
      const parentFolder = this.folderID
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus.$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        structureID: this.containedBy && this.containedBy.origin
      }, this.heritableFolders) // Para el combo de heredables
    },
    addInnerFolder (folderData) {
      const parentFolder = folderData.itemID
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus.$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        structureID: folderData.origin
      }, this.heritableFolders) // Para el combo de heredables
    },
    actualizar () {
      this.disabledButton = true
      this.actualizarButtonLoading = true

      if (this.folderID === '0') return

      axios.post(uris.URL_ADD_CUBE_PERMISSION, {
        itemID: this.folderID
      })
        .then((response) => {
          console.log(response)
          eventBus.$emit('open-custom-snack-bar', {message: 'Se actualizó los permisos a todos los usuarios', itsOk: true})
        })
        .catch((err) => {
          console.warn('No se ha podido actualizar los permisos de los usuarios', err)
        })
        .finally(() => {
          this.disabledButton = false
          this.actualizarButtonLoading = false
        })
    },
    bloquear () {
      this.disabledButton = true
      this.bloquearButtonLoading = true

      if (this.folderID === '0') return

      axios.post(uris.URL_REMOVE_CUBE_PERMISSION, {
        itemID: this.folderID
      })
        .then((response) => {
          console.log(response)
          eventBus.$emit('open-custom-snack-bar', {message: 'Se bloqueo los permisos a todos los usuarios', itsOk: true})
        })
        .catch((err) => {
          console.warn('No se ha podido bloquear los permisos de los usuarios', err)
        })
        .finally(() => {
          this.disabledButton = false
          this.bloquearButtonLoading = false
        })
    }
  },
  computed: {
    haveFavoriteReport: function () {
      return this.topFavoriteReports.length > 0
    }
  },
  components: {
    FolderList,
    ReportList,
    StrategioAppBar,

    FolderFormDialog,
    ReportFormDialog,
    DropItemDialog,
    ReplicateFolderDialog,
    NewItemsManagerDialog,
    ShowUsersFolderPermissions,

    CustomSnackBar
  }
}
</script>
<style>
.download-cube-no-report {
  text-align: center;
  margin-top: 128px;
  font-size: 30px;
}

.strategio-loading-main {
  text-align: center;
  margin-top: 128px;
}
.strategio-loading-main-message {  
  font-weight: 500;
  font-size: 18px;
  color: black;
}

.expansionbusq-enter-active {
  transition: max-height .2s linear;
  max-height: 112px;
  padding: 0;
  overflow: hidden;
}
.expansionbusq-leave-active {
  transition: max-height .1s linear;
  max-height: 0px;
  padding: 0;
  overflow: hidden;
}
.expansionbusq-enter {
  max-height: 0px;
  padding: 0;
  opacity: 0;
}
.expansionbusq-leave {
  max-height: 112px;
  padding: 0;
  opacity: 0;
}

.strategio-title-mas-usados {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 50px;
  line-height: 52px;
  color: #000000;
}

.strategio-title-favorite {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 43px;
  color: #000000;
}
</style>


// WEBPACK FOOTER //
// src/routes/download-cube.vue